import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0be130be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  href: "/",
  class: "recording-teaser"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fad fa-microphone-alt" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Eigene Aufnahme erstellen ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Dieser Dienst wird ausschliesslich für den Bildungsbereich in der Schweiz angeboten.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainPanel = _resolveComponent("MainPanel")!
  const _component_LinksPanel = _resolveComponent("LinksPanel")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_MainPanel, {
      recordingId: _ctx.recordingId,
      content: _ctx.content
    }, null, 8, ["recordingId", "content"]),
    (_ctx.recordingId)
      ? (_openBlock(), _createElementBlock("a", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createVNode(_component_LinksPanel, { content: _ctx.content }, null, 8, ["content"])
  ]))
}